import React from 'react'
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../common/components/form/form.module'

export default function NexusARecordTypesBasicInfoComponent({
  handleInnerFormChange, selectedNexusARecordTypes
}: any) {

  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Name',
                )
              }}
              type="text"
              value={selectedNexusARecordTypes?.Name}
            />
            <InputContainer
              label="Description"
              name="Description"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Description',
                )
              }}
              type="text"
              value={selectedNexusARecordTypes?.Description}
            />
            <InputContainer
              label="Display Order"
              name="DisplayOrder"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'DisplayOrder',
                )
              }}
              type="number"
              value={selectedNexusARecordTypes?.DisplayOrder}
            />
          </div>
        }
        expandedPanel="userInfo"
        headerTitle="Basic Info"
      />
    </>
  )
}